import { Moon01, Sun, SunSetting01 } from '@v2/ui';
import { FlightClass } from '../../types';

export const Classes = [
  {
    label: 'Economy',
    value: 'Economy',
  },
  {
    label: 'Executive',
    value: 'Business',
  },
];

export const timeOptions = [
  {
    title: 'Morning',
    icon: <Sun />,
    description: '12am - 12pm',
    value: 'morning',
  },
  {
    title: 'Noon',
    icon: <SunSetting01 />,
    description: '12pm - 6pm',
    value: 'noon',
  },
  {
    title: 'Night',
    icon: <Moon01 />,
    description: '6pm - 12am',
    value: 'night',
  },
];

export const starRatingoptions = [
  { id: 'nonstop', value: 'nonstop', label: 'Non-stop (3)', rightText: '+ $0' },
  { id: '1stop', value: '1stop', label: '1 stop (3)', rightText: '+ $0' },
];

export const airlineOptions = [
  {
    id: 'americanAirlines',
    label: 'American Airlines (15)',
    rightText: '+ $0',
  },
  { id: 'delta', label: 'Delta Air Lines (9)', rightText: '+ $39' },
  { id: 'jetBlue', label: 'JetBlue Airways (11)', rightText: '+ $66' },
  { id: 'united', label: 'United Airlines (6)', rightText: '+ $0' },
  { id: 'alaska', label: 'Alaska Airlines (5)', rightText: '+ $318' },
];

export const classOptions = [
  { id: 'economy', label: 'Economy', rightText: '' },
  { id: 'executive', label: 'Executive', rightText: '' },
];

export enum CabinClass {
  PremiumFirst = 'P',
  First = 'F',
  PremiumBusiness = 'J',
  Business = 'C',
  PremiumEconomy = 'S',
  Economy = 'Y',
}

export const flightClasses: FlightClass[] = [
  { id: '1', name: 'Economy', value: CabinClass.Economy },
  { id: '2', name: 'Premium Economy', value: CabinClass.PremiumEconomy },
  { id: '3', name: 'Business', value: CabinClass.Business },
  { id: '4', name: 'Premium Business', value: CabinClass.PremiumBusiness },
  { id: '5', name: 'First', value: CabinClass.First },
  { id: '6', name: 'Premium First', value: CabinClass.PremiumFirst },
];
